import { useState } from 'react'
import webapplogo from "../assest/webapplogo.png"
import CustomTextInput from '../Components/CustomTextInput'
import CustomButton from '../Components/CustomButton'
import CustomPasswordInput from '../Components/CustomInputPassword'
import { useNavigate } from 'react-router-dom'
import { authLogin } from '../redux/actions/authAction'
import { invalidemail } from '../Config/Constant'
import { notification } from 'antd';

const Login = () => {
    const [email, setEmail] = useState('')
    const [Password, setPassword] = useState('')
    const navigate = useNavigate()

    // Handle Enter key press in input fields
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            loginAccount();
        }
    }

    const loginAccount = () => {
        try {
            const emailDomain = email.split('@')[1];

            if (invalidemail.includes(emailDomain)) {

                return notification.error({
                  message: 'Invalid Email',
                  description: 'The email domain is not allowed.',
                });
              }
            const payload = {
                email,
                Password,
            }
            authLogin(payload, navigate)
            //  navigate('/dashboard/overview')
        } catch (error) {
            console.log('error', error);

        }
    }





    return (
        <div className='contanier'>
            <div className='loginpagemain'>

                <div className='loginpage' 

                >

                    {/* <Image className='webimage' src={webapplogo}/> */}
                    <img className='webimage' src={webapplogo} alt=''></img>

                    <p>
                        Welcome back!

                    </p>
                    <h2>Please enter details</h2>
                    <div className='textinput'>
                        <p>
                            Email Address
                        </p>
                        <CustomTextInput 
                            value={email} 
                            onChange={setEmail} 
                            onKeyDown={handleKeyDown}
                        />

                        <p className='pt-3'>
                            Password
                        </p>
                        <CustomPasswordInput 
                            value={Password} 
                            onChange={setPassword} 
                            onKeyDown={handleKeyDown}
                        />
                        <div className='button_Content'>
                            <CustomButton
                                onClick={loginAccount}
                                // onClick={()=>{
                                //     navigate('/dashboard/overview')
                                // }}
                                text={'Login'} />
                        </div>
                        <p className='notaccount'>
                            Don’t have an account? <span onClick={() => {
                                navigate('/signup')
                            }} > Sign Up</span>
                        </p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Login